<template>
	<div class="form-input">
		<!-- Text block w/ label -->
		<label :for="_uid" >{{title}}</label>
		<div :class='{focus: focussed, "input-block": true}'>
			<div class="prefix" v-if='prefix'>{{prefix}}</div>
			<div class="spacer" v-if='!prefix'>&nbsp;</div>

			<date-picker v-model="date" :config="options"></date-picker>
			<!--<input
				:id="_uid"
				:placeholder='placeholder'
				ref="item"
				:name="name"
				:value="value"
				@input="update()"
				:disabled="disabled"
				type="text"
			required>-->
		</div>
	</div>
</template>

<script>

import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
	name: "FormDatePicker",
	components: {
		datePicker
	},
	props: {
		value: {
			default: ""
		},
		required: {
			default: false
		},
		prefix: {
			default: false
		},
		disabled: {
			default: false
		},
		title: {
			default: ""
		},
		name: {
			default: "input"
		},
		placeholder: {
			default: ""
		},
		hint: {
			default: ""
		}
	},
	data(){
		return {
			date: new Date("2000-01-02"),
			options: {
				format: 'YYYY-MM-DD',
				useCurrent: false,
				icons: {
					time: 'far fa-clock',
					date: 'far fa-calendar',
					up: 'fas fa-arrow-up',
					down: 'fas fa-arrow-down',
					previous: 'fas fa-chevron-left',
					next: 'fas fa-chevron-right',
					today: 'fas fa-calendar-check',
					clear: 'far fa-trash-alt',
					close: 'far fa-times-circle'
				}
			},
			focussed: false
		}
	},
	watch: {
		date: function(){
			this.$emit('input', this.date);
		}
	},
	method: {
		onFocus(){
			this.focussed = true;
		},
		offFocus(){
			this.focussed = false;
		}
	}
};
</script>

<style scoped lang="scss">
	.input-block{
		position: relative;
		display: flex;
		align-items: center;
		color: #919eab;
		cursor: text;
		border: 1px solid #CDCDCD;
		border-radius: 7px;
	}
	label{
		width: 100%;
		margin-bottom: 5px;
		font-family: 'proximanova-bold';
		font-size: 18px;
	}
	input{
		position: relative;
		z-index: 20;
		display: block;
		flex: 1 1 0%;
		width: 100%;
		margin: 0;
		padding: 8px 20px 8px 3px;
		background: none;
		border: 1px solid transparent;
		height: 42px;
	}
	input:focus{
		outline: 0px;
		box-shadow: 0px;
		border: 0px;
	}
	.prefix{
		position: relative;
		z-index: 20;
		text-align: center;
		width: 20px;
		margin-left: 5px;
	}
	.spacer{
		width: 10px;
	}
</style>
